(function () {
	function renderAddToCartButton(
		_defaultTemplate,
		hit,
		html,
		components,
		trackSearchAttribution,
	) {
		return '';

		const price = hit.price;
		if (price >= 9999) {
			return html`<p class="ais-hit--inquire">Inquire</p>`;
		}

		return html`
			<p class="ais-hit--cart">
				${hit.can_order
				? html`
							<button
								class="ais-hit--cart-button"
								data-form-id="algolia-add-to-cart-${hit.objectID}"
							>
								${algoliaShopify.translations.addToCart}
							</button>
					  `
				: html`
							<p
								class="ais-hit--inquire"
							>
								Inquire
							</p>
					  `}
			</p> 
		`;
	}

	function renderVendor(hit,
		html, components) {
		return html`<div class="ais-hit--vendor vendor">
		${components.Highlight({
						attribute: "vendor",
						hit,
					})}
		</div>`;
	}

	function getProductByHandle(handle) {
		return fetch(`/products/${handle}.js`)
			.then((response) => response.json())
			.then((product) => {
				return product;
			})
			.catch((error) => {
				console.error("Error fetching product data:", error);
				return null;
			});
	}

	

	function renderOutOfStock(hit,html){
			
			if (hit.inventory_quantity > 0) {
				return;
			}

			getProductByHandle(hit.handle).then((res) => {
				const inventoryManagement = res.variants[0].inventory_management;
				const id = `#ais-hit--out-of-stock-${hit.handle}`;
				
				if(inventoryManagement !== 'shopify') return;

				jQuery(document).find(id).replaceWith(`<div class="ais-hit--out-of-stock">Sold Out</div>`);
			});


			return html`<div id="ais-hit--out-of-stock-${hit.handle}"></div>`;
	}

	function renderPrice(
		_defaultTemplate,
		hit,
		html,
		components,
		trackSearchAttribution,
	) {
		const price = hit.price;
		if (price >= 60000) {
			return "";
		}

		return html`
			<p class="ais-hit--price">
				${algoliaShopify.helpers.displayPrice(
			hit,
			hit._distinct,
		)}
				${!hit._distinct &&
			html`
					<span class="ais-hit--price-striked"
						><span
							>${algoliaShopify.helpers.displayStrikedPrice(
				hit.price,
				hit.compare_at_price,
			)}</span
						></span
					>
				`}
				${!hit._distinct &&
			html`
					<span class="ais-hit--price-discount"
						>${algoliaShopify.helpers.displayDiscount(
				hit.price,
				hit.compare_at_price,
				hit.price_ratio,
			)}</span
					>
				`}
			</p>
		`;
	}

	document.addEventListener("algolia.hooks.initialize", function () {
		algoliaShopify.hooks.registerHook(
			"beforeInstantSearchProductTemplate",
			function (
				_defaultTemplate,
				hit,
				html,
				components,
				trackSearchAttribution,
			) {
				const hitImage = algoliaShopify.helpers.renderImage(hit, 250);
				return html`
					<div
						class="ais-hit ais-product ${hit.price > 60000
						? "hide-add-cart"
						: ""}"
						data-algolia-index="${hit.index}"
						data-algolia-position="${hit.productPosition}"
						data-algolia-queryid="${hit.queryID}"
						data-algolia-objectid="${hit.objectID}"
						data-handle="${hit.handle}"
						data-variant-id="${hit.objectID}"
						data-distinct="${hit._distinct}"
						data-product-id="${hit.id}"
						onClick="${() => trackSearchAttribution(hit)}"
					>
						<div class="ais-hit--picture-wrapper">
							<img
								class="ais-hit--picture"
								src="${hitImage.src}"
								srcset="${hitImage.srcset}"
								sizes="${hitImage.sizes}"
								alt="${hit.title} - ${hit.variant_title}"
							/>
							${renderOutOfStock(hit, html)}
						</div>
						

						<div class="ais-hit--details">
							<p class="ais-hit--title">
								<a
									data-algolia-index="${hit.index}"
									data-algolia-position="${hit.productPosition}"
									data-algolia-queryid="${hit.queryID}"
									data-algolia-objectid="${hit.objectID}"
									href="${algoliaShopify.helpers.instantsearchLink(
							hit,
						)}"
									title="${algoliaShopify.helpers.fullTitle(
							hit.title,
							hit._distinct,
							hit.variant_title,
						)}"
								>
									${components.Highlight({
							attribute: "title",
							hit,
						})}
									${algoliaShopify.helpers.variantTitleAddition(
							hit,
							hit._distinct,
						)}
								</a>
							</p>
							<p
								class="ais-hit--subtitle"
								title="${hit.product_type}${algoliaShopify.translation_helpers.by(
							hit.vendor,
						)}"
							>
								${components.Highlight({
							attribute: "product_type",
							hit,
						})}
						</p>
							${renderVendor(
						hit,
						html,
						components
					)}
							${renderPrice(
						_defaultTemplate,
						hit,
						html,
						components,
						trackSearchAttribution,
					)}

							<!-- Extra info examples - Remove the display: none to show them -->
							<p class="ais-hit--info" style="display: none">
								${hit.sku &&
					html`
									<span class="algolia-sku"
										>${components.Highlight({
						attribute: "sku",
						hit,
					})}</span
									>
								`}
								${hit.barcode &&
					html`
									<span class="algolia-barcode"
										>${components.Highlight({
						attribute: "barcode",
						hit,
					})}</span
									>
								`}
								${hit.weight &&
					html`
									<span class="algolia-weight"
										>${hit.weight}</span
									>
								`}
								${!hit.taxable &&
					html`
									<span class="algolia-taxable"
										>${algoliaShopify.translations
							.taxFree}</span
									>
								`}
							</p>
							<!-- Tags example - Remove the display: none to show them -->
							<p class="ais-hit--tags" style="display: none">
								${hit?._highlightResult.tags?.map(
								(tag) =>
									html`
											<span class="ais-hit--tag"
												>${tag.value}</span
											>
										`,
							)}
							</p>
							${!hit._distinct &&
					html`
								<form
									id="algolia-add-to-cart-${hit.objectID}"
									style="display: none;"
									action="/cart/add"
									method="post"
									enctype="multipart/form-data"
								>
									<input
										type="hidden"
										name="id"
										value="${hit.objectID}"
									/>
								</form>
								${renderAddToCartButton(
						_defaultTemplate,
						hit,
						html,
						components,
						trackSearchAttribution,
					)}
							`}
						</div>
					</div>
				`;
			},
		);
	});
	document.addEventListener("algolia.hooks.initialize", function () {
		algoliaShopify.hooks.registerHook(
			"beforeInstantSearchMainTemplate",
			function (_defaultTemplate, data, html) {
				return html`
					<div class="ais-page">
						<h1 class="ais-h2">
							${algoliaShopify.translations.searchTitle}
						</h1>
						<div class="ais-input">
							<div class="ais-search-box-container"></div>
							<div class="ais-input-button">
								<div class="ais-clear-input-icon"></div>
							</div>
						</div>
						<div class="ais-facets-button">
							${algoliaShopify.translations.showFilters}
						</div>
						<div class="ais-facets">
							
							
							${data.facets.map(
					(facet) =>
						html`
										<div
											class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
										>
											<label
												for="${facet.escapedName}"
												class="ais-range-slider--header ais-facet--header ais-header"
												>${facet.title}</label
											>
											<input
												class="ais-dropdown-checkbox"
												type="checkbox"
												id="${facet.escapedName}"
												name="dropdown"
											/>
											<div
												class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
											></div>
										</div>
									`,
				)}
							<div class="ais-facet-dropdown-wrapper custom-sortBy-widget">
									<label for="sortBy" class="ais-range-slider--header ais-facet--header ais-header">Sort By</label>
									<input class="ais-dropdown-checkbox" type="checkbox" id="sortBy" name="sortBy" />
									<div class="custom-sortBy-widget__content ais-facet-dropdown-container">
										<div class="ais-Panel">
											<div class="ais-Panel-body">
												<div>
													<div class="ais-sort">
																${data.multipleSortOrders
													? html`
															<span
																class="ais-sort-orders-container"
															></span>
																	`
													: html`				
															${algoliaShopify.translations
															.relevance}
																	`}
													</div>
												</div>
											</div>
										</div>
										
									</div>
									
							</div>
						</div>
						<div class="ais-block">
							<div class="refinements-wrapper">
								<div class="ais-current-refined-values-container"></div>
								<div class="ais-clear-refinements-container"></div>
							</div>										
							<div class="ais-search-header">
								<div class="ais-stats-container">
									<div
										class="ais-clear-refinements-container-2"
									></div>
									<div
										class="ais-current-refined-values-container-2"
									></div>
								</div>
								<div class="ais-change-display">
									<span
										class="ais-change-display-block ais-change-display-selected"
										><svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 1664 1450"
										>
											<path
												d="M768 512v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90zM768 1280v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90zM1664 512v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90zM1664 1280v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90z"
											></path></svg
									></span>
									<span class="ais-change-display-list"
										><svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 1792 1450"
										>
											<path
												d="M512 288v-192q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v192q0 40 28 68t68 28h320q40 0 68-28t28-68zM512 800v-192q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v192q0 40 28 68t68 28h320q40 0 68-28t28-68zM1792 288v-192q0-40-28-68t-68-28h-960q-40 0-68 28t-28 68v192q0 40 28 68t68 28h960q40 0 68-28t28-68zM512 1312v-192q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v192q0 40 28 68t68 28h320q40 0 68-28t28-68zM1792 800v-192q0-40-28-68t-68-28h-960q-40 0-68 28t-28 68v192q0 40 28 68t68 28h960q40 0 68-28t28-68zM1792 1312v-192q0-40-28-68t-68-28h-960q-40 0-68 28t-28 68v192q0 40 28 68t68 28h960q40 0 68-28t28-68z"
											></path></svg
									></span>
								</div>
								
							</div>
							<div
								class="ais-hits-container ais-results-as-block"
							></div>
						</div>
						<div class="ais-pagination-container"></div>
					</div>
				`;
			},
		);
	});

	document.addEventListener("algolia.hooks.initialize", () => {
		algoliaShopify.hooks.registerHook(
			"beforeInstantSearchStartAddWidgets",
			() => {
				// Not all widgets are available
				const { sortBy } = window.algoliaShopify.externals.widgets;

				const connectSortBy = window.instantsearch.connectors.connectSortBy;
				const renderSortBy = (renderOptions, isFirstRender) => {
					const { options, refine, widgetParams, currentRefinement } = renderOptions;
					const container = widgetParams.container;

					container.innerHTML = '';
					options.forEach(function (option) {
						var id = 'sort-' + option.value;

						var label = document.createElement('label');
						var span = document.createElement('span');
						label.setAttribute('for', id);
						label.style.display = 'block';
						label.style.cursor = 'pointer';

						var input = document.createElement('input');
						input.type = 'radio';
						input.name = 'sort-by';
						input.id = id;
						input.value = option.value;
						input.checked = option.value === currentRefinement;
						input.addEventListener('change', function () {
							refine(option.value);
						});

						const text = document.createTextNode(' ' + option.label);

						
						label.appendChild(input);
						label.appendChild(span);
						label.appendChild(text);
						container.appendChild(label);
      				});
				};
				const customSortBy = connectSortBy(renderSortBy);

				return [
					customSortBy({
						container: document.querySelector(".ais-sort-orders-container"),
						items: algoliaShopify.collectionSortOrders
					})
				];
			},
		);
	});



	document.addEventListener("algolia.hooks.initialize", () => {
	algoliaShopify.hooks.registerHook(
		"afterInstantSearchStartRemoveDefaultWidgets",
		(defaultWidgets) => {
			// Find and return the default pagination widget to remove it
			const defaultPaginationWidget = defaultWidgets.find(
				(widget) => widget.$$widgetType === "ais.sortBy",
			);

			return [];
		},
	);
});

	// Sao chép nội dung từ container gốc sang container thứ 2
	document.addEventListener("DOMContentLoaded", function () {

		// Chờ Algolia render xong
		setTimeout(function () {
			return;

			function syncContainers() {
				const clearContainer1 = document.querySelector(
					".ais-clear-refinements-container",
				);
				const clearContainer2 = document.querySelector(
					".ais-clear-refinements-container-2",
				);
				const refineContainer1 = document.querySelector(
					".ais-current-refined-values-container",
				);
				const refineContainer2 = document.querySelector(
					".ais-current-refined-values-container-2",
				);

				if (clearContainer1 && clearContainer2) {
					clearContainer2.innerHTML = clearContainer1.innerHTML;
					// Sao chép sự kiện click
					const buttons1 = clearContainer1.querySelectorAll("button");
					const buttons2 = clearContainer2.querySelectorAll("button");
					buttons2.forEach((btn, index) => {
						if (buttons1[index]) {
							btn.addEventListener("click", function () {
								buttons1[index].click();
							});
						}
					});
				}

				if (refineContainer1 && refineContainer2) {
					console.log("Synchronizing refine containers");

					refineContainer2.innerHTML = refineContainer1.innerHTML;
					// Sao chép sự kiện click cho các link xóa filter
					const links1 = refineContainer1.querySelectorAll(
						"a.ais-current-refined-values--link",
					);
					const links2 = refineContainer2.querySelectorAll(
						"a.ais-current-refined-values--link",
					);
					links2.forEach((link, index) => {
						console.log("Setting up click event for link", index);

						if (links1[index]) {
							link.addEventListener("click", function (e) {
								e.preventDefault();
								console.log(
									"Clicking link 2, triggering link 1",
								);
								links1[index].click();
							});
						}
					});

					// Cũng xử lý các button nếu có
					const buttons1 = refineContainer1.querySelectorAll(
						"button, .ais-current-refined-values--delete",
					);
					const buttons2 = refineContainer2.querySelectorAll(
						"button, .ais-current-refined-values--delete",
					);
					buttons2.forEach((btn, index) => {
						console.log("Setting up click event for button", index);

						if (buttons1[index]) {
							btn.addEventListener("click", function (e) {
								e.preventDefault();
								buttons1[index].click();
							});
						}
					});
				}
			}

			// Đồng bộ ngay lập tức
			syncContainers();

			// Đồng bộ định kỳ khi có thay đổi
			const observer = new MutationObserver(syncContainers);
			const container1 = document.querySelector(".ais-facets");
			if (container1) {
				observer.observe(container1, {
					childList: true,
					subtree: true,
				});
			}

			// Đồng bộ khi có sự kiện search
			document.addEventListener("click", function (e) {
				if (
					e.target.closest(".ais-facet") ||
					e.target.closest(".ais-clear-refinements") ||
					e.target.closest(".ais-current-refined-values")
				) {
					setTimeout(syncContainers, 100);
				}
			});
		}, 1000);
	});
	const { numericMenu } = window.instantsearch.widgets;
	document.addEventListener("algolia.hooks.initialize", function () {
		algoliaShopify.hooks.registerHook(
			"beforeInstantSearchOptions",
			function (options) {
				// Loop through the facet widgets.
				console.log("options.facets.widgets", options.facets);
				const widgets = options.facets.widgets.map((widget) => {
					// Only update the refinementList widget params.


					console.log('widget.params.attribute', widget.params.attribute, widget.params)

					if (widget.params.attribute === "inventory_available") { 
						const params = {
							...widget.params,
							transformItems(items) {
								return items.map((item) => {
									console.log(item);
									if(item.value === "true"){
										return {
											...item,
											label: 'In stock'
										}
									}

									if(item.value === "false"){
										return {
											...item,
											label: 'Out of stock'
										}
									}

									return item;
								});
							},
						};

						return {
							...widget,
							params: params,
						};

					}

					if (widget.params.attribute === "category.lvl2") { 
						const params = {
							...widget.params,
							transformItems(items) {
								return items.map((item) => {
									const labels = item.label.split(" > ")

									return {
										...item,
										label: labels[labels.length - 1]
									};
								});
							},
						};

						return {
							...widget,
							params: params,
						};

					}

					if (widget.params.attribute === "vendor111") {
						const params = {
							...widget.params,
							transformItems(items) {
								const allowedVendors = [
									"ashi",
									"gabriel",
									"sylvie",
									"parade",
									"william henry",
									"hamilton",
									"tissot",
									"shinola",
								];
								const regexPattern = new RegExp(
									`^(${allowedVendors.join("|")})`,
									"i",
								);
								const filteredItems = items.filter((item) =>
									regexPattern.test(item.value),
								);
								return filteredItems;
							},
							limit: 100,
						};
						return {
							...widget,
							params: params,
						};
					}

					if (
						widget.params.attribute === "meta.itemDetails.Stone_TWT"
					) {
						const params = {
							...widget.params,
							items: [
								{ label: "Under .50ct", end: 0.5 },
								{
									label: ".51ct. to 1.00ct.",
									start: 0.51,
									end: 1,
								},
								{
									label: "1.01ct. to 1.50ct.",
									start: 1.01,
									end: 1.5,
								},
								{
									label: "1.51ct. to 2.00ct.",
									start: 1.51,
									end: 2,
								},
								{
									label: "2.01ct. to 2.50ct.",
									start: 2.01,
									end: 2.5,
								},
								{
									label: "2.51ct. to 3.00ct.",
									start: 2.51,
									end: 3,
								},
								{
									label: "3.01 ct to 3.99 ct.",
									start: 3.01,
									end: 3.99,
								},
								{
									label: "4.0 ct and Up",
									start: 4,
								},
							],
							transformItems(items) {
								return items.map((item) => ({
									...item,
								}));
							},
						};
						return {
							...widget,
							facet: {
								...widget.facet,
								available_types: [
									"menu",
									"slider",
									"conjunctive",
									"disjunctive",
									"numericMenu",
								],
								type: "numericMenu",
							},
							name: "numericMenu",
							params: params,
							widget: (params) => {
								return numericMenu(params);
							},
						};
					}
					
					if (widget.params.attribute === "price111") {
						console.log('widget.params.attribute', widget.params.attribute)
						const params = {
							...widget.params,
							items: [
								{ label: "Under $500", end: 500 },
								{
									label: "$500 - $1,500",
									start: 500,
									end: 1500,
								},
								{
									label: "$1,500 - $2,500",
									start: 1500,
									end: 2500,
								},
								{
									label: "$2,500 - $5,000",
									start: 2500,
									end: 5000,
								},
								{
									label: "$5,000 - $10,000",
									start: 5000,
									end: 10000,
								},
							],
							transformItems(items) {
								return items.map((item) => ({
									...item,
								}));
							},
						};
						return {
							...widget,
							facet: {
								...widget.facet,
								available_types: [
									"menu",
									"slider",
									"conjunctive",
									"disjunctive",
									"numericMenu",
								],
								type: "numericMenu",
							},
							name: "numericMenu",
							params: params,
							widget: (params) => {
								return numericMenu(params);
							},
						};
					}

					if (widget.params.attribute === "meta.itemDetails.Length") {
						const params = {
							...widget.params,
							transformItems(items) {
								const newItems = items.sort((a, b) => {
									const aValue = parseFloat(a.value);
									const bValue = parseFloat(b.value);
									return aValue - bValue;
								});

								return newItems;
							},
							limit: 100,
						};
						return {
							...widget,
							params: params,
						};
					}

					if (
						widget.params.attribute === "meta.itemDetails.MM_Size"
					) {
						const params = {
							...widget.params,
							transformItems(items) {
								const newItems = items.sort((a, b) => {
									const aValue = parseFloat(a.value);
									const bValue = parseFloat(b.value);
									return aValue - bValue;
								});

								return newItems;
							},
							limit: 100,
						};
						return {
							...widget,
							params: params,
						};
					}

					if (
						widget.params.attribute === "meta.itemDetails.Style" &&
						collectionHandle === "engagement-rings"
					) {
						const params = {
							...widget.params,
							transformItems(items) {
								const newItems = items.sort((a, b) => {
									const aValue = parseFloat(a.value);
									const bValue = parseFloat(b.value);
									return aValue - bValue;
								});

								return [];
							},
							limit: 100,
						};
						return {
							...widget,
							params: params,
						};
					}

					if (widget.name !== "refinementList") {
						return widget;
					}

					// This updates all `refinementList` widgets.
					// If you only want to update specific facet(s),
					// you can target them by checking the value of `widget.params.container`.

					return {
						...widget,
						params: {
							...widget.params,
							//limit: 5,
							showMore: true,
						},
					};
				});

				const list = options.facets.list.map((item) => {
					const name = item.name;
					if (name === "meta.itemDetails.Stone_TWT") {
						return {
							...item,
							type: "numericMenu",
							available_types: [
								"menu",
								"slider",
								"conjunctive",
								"disjunctive",
								"numericMenu",
							],
						};
					}

					if (
						name === "meta.itemDetails.Setting_Style" &&
						collectionHandle === "engagement-rings"
					) {
						return {
							...item,
							title: "Style",
						};
					}
					return item;
				});

				const shown = options.facets.shown.map((item) => {
					const name = item.name;
					if (name === "meta.itemDetails.Stone_TWT") {
						return {
							...item,
							type: "numericMenu",
							available_types: [
								"menu",
								"slider",
								"conjunctive",
								"disjunctive",
								"numericMenu",
							],
						};
					}
					return item;
				});

				return {
					...options,
					facets: {
						...options.facets,
						widgets,
						list: list,
						shown,
					},
				};
			},
		);
	});

	document.addEventListener("algolia.hooks.initialize", function () {
		algoliaShopify.hooks.registerHook(
			"beforeInstantSearchFacetPanelOptions",
			function (params, facet) {
				console.log("params", params);

				return {
					...params,
				};
			},
		);
	});

	// expand when face have a item checked
	function autoExpandFacets() {
		var facets = jQuery(document).find(
			".ais-facets .ais-facet-dropdown-wrapper",
		);
		jQuery.each(facets, function (index, el) {
			var checkbox = jQuery(el).find(".ais-dropdown-checkbox");
			var checkedItems = jQuery(el).find(
				".ais-RefinementList-item--selected",
			);
			if (checkedItems.length) {
				jQuery(checkbox).prop("checked", true);
			}
		});

		var numericMenuFacets = jQuery(".ais-facets .ais-facet-numericMenu");
		jQuery.each(numericMenuFacets, function (index, el) {
			var checkbox = jQuery(el).find(".ais-dropdown-checkbox");
			var checkedItems = jQuery(el).find(
				".ais-NumericMenu-item--selected",
			);
			if (checkedItems.length) {
				jQuery(checkbox).prop("checked", true);
			}
		});
	}

	setTimeout(() => {
		autoExpandFacets();
	}, 2000);



})();
